// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3754) return "static/chunks/3754-1e49b95911cb868b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6474":"a65f42f2a171a453","6820":"f4687f14fc28ba4c","9191":"6c84a3f43bb0b2df"}[chunkId] + ".js";
};